exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3P_Xy{margin:40px 0;background:#fff;border-radius:8px;padding:20px;-webkit-box-shadow:0 2px 4px rgba(0,0,0,.1);box-shadow:0 2px 4px rgba(0,0,0,.1)}.Qu7wm{background:#f0f0f0;padding:12px 20px;margin:-20px -20px 20px;border-radius:8px 8px 0 0;font-size:16px;font-weight:600}.U3ON9{display:inline-block}._3hynx{margin-bottom:10px;font-size:14px}._3hynx thead{background:#34495e;color:#fff}._3hynx td,._3hynx th{text-align:center;vertical-align:middle}._3sj19 th{border-color:#2c3e50!important}._3AZ6D{background:#2c3e50!important;min-width:150px}._1f7ue,._3AZ6D{color:#fff!important;font-weight:600}._1f7ue{background:#34495e!important;min-width:120px}.PliTE{font-size:14px;font-weight:700;display:block;margin-top:4px}._1kPOh{font-size:12px;display:block;margin-top:2px;opacity:.9}._1AWaB{width:120px;background:#ecf0f1;font-weight:700;text-align:right!important}._1AWaB.vYNhl{background:#ffd3da}._3PpmZ{width:180px;font-weight:500;color:#27ae60;font-size:15px}._2ldFC{font-size:12px;color:#2e3333;font-style:italic;margin-top:10px;padding-left:10px}", ""]);

// exports
exports.locals = {
	"alcanceContent": "_3P_Xy",
	"alcanceTitle": "Qu7wm",
	"porcentajeTable": "U3ON9",
	"comisionTable": "_3hynx",
	"headerRow": "_3sj19",
	"alcanceHeader": "_3AZ6D",
	"membresiaHeader": "_1f7ue",
	"precioEsperado": "PliTE",
	"membresiaTitulo": "_1kPOh",
	"rangoCell": "_1AWaB",
	"sustituto": "vYNhl",
	"importeCell": "_3PpmZ",
	"footnote": "_2ldFC"
};